<template>
  <div class="login-wrapper">
    <div class="card-body text-secondary text-center card-login">
      <img class="card-img-top logo" src="../images/dekra_2.png" />
      <h4 style="color:#202124;">Iniciar sesión</h4>
      <h6 style="color:#202124;">Acceder a SOHO-TMS </h6>
      <form name="form">
        <div class="form-group mt-4">
          <input
            v-model="user.username"
            v-validate="'required'"
            type="text"
            class="form-control texfield-formulario"
            name="username"
            placeholder="Usuario"
          />
          <div
            v-if="errors.has('username')"
            class="alert alert-danger"
            role="alert"
          >
            Usuario obligatorio
          </div>
        </div>
        <div class="form-group">
          <input
            v-model="user.password"
            v-validate="'required'"
            type="password"
            class="form-control texfield-formulario"
            name="password"
            placeholder="Contraseña"
          />
          <div
            v-if="errors.has('password')"
            class="alert alert-danger"
            role="alert"
          >
            Contraseña obligatoria
          </div>
        </div>
        <!-- <div class="form-group">
            <b-link to="/recuperar" class="link"
              ><p align="left" style="font-size:90%;color:#506A5B;">
                Recuperar contraseña
              </p></b-link
            >
          </div>-->
        <div class="form-group d-flex justify-content-end">
          <b-button
            v-on:click="handleLogin"
            variant="success"
            class="mt-3 "
            :disabled="loading"
          >
            <span
              v-show="loading"
              class="spinner-border spinner-border-sm "
            ></span>
            <span>Acceder</span>
          </b-button>
        </div>

        <div class="form-group">
          <div v-if="message" class="alert alert-danger" role="alert">
            {{ message }}
          </div>
        </div>
      </form>
     <!-- <b-button size="sm" variant="outline-primary" v-b-modal.modal-imagen>Configurar navegador</b-button> -->

    </div>
    <b-modal id="modal-imagen" title="" size="lg">

      <img src="../images/manual_navegador.png" alt="" class="img-fluid" />
      <template v-slot:modal-footer>
        <div class="d-none"></div> </template>
    </b-modal>
  </div>
</template>

<script>
import User from '../models/user';

export default {
  name: 'Login',
  data() {
    return {
      user: new User('', ''),
      loading: false,
      message: ''
    };
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    }
  },
  created() {
    if (this.loggedIn) {
      localStorage.getItem('idioma', 'ESP');
      this.$router.push('/principal');
    }
  },
  methods: {
    handleLogin() {
      this.loading = true;
      this.$validator.validateAll().then(isValid => {
        if (!isValid) {
          this.loading = false;
          return;
        }

        if (this.user.username && this.user.password) {
          this.$store.dispatch('auth/login', this.user).then(
            () => {
              this.$router.push('/principal');
            },
            error => {
              this.loading = false;
              this.message =
                (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
                error.message ||
                error.toString();
            }
          );
        }
      });
    }
  },
  components: {}
};
</script>

<style scoped>
.login-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: white;
  z-index: 9999; /* Ensure it covers everything */
  overflow-y: auto; /* Allow scrolling */
  display: flex;
  align-items: center; /* Vertical center */
  justify-content: center; /* Horizontal center */
}

/* Override existing card margin to work better with flex centering if needed, 
   but user said "keep card as is". 
   The existing card has margin: 150px auto 25px. 
   If I use flex centering, I might want to remove the top margin or let it be.
   Let's keep the card mostly as is, but maybe adjust margin if it looks weird in flex.
   Actually, if I use flex centering, the 'margin: 150px' will push it down from center.
   I should probably reset the margin for the card INSIDE this wrapper.
*/
.login-wrapper .card-login {
  margin: 0; /* Let flex handle centering */
}
</style>
